import React from "react";

export default function PassPromoDateCard({ month, day, scale = 1 }) {
  return (
    <div className="dp-promo-datecard" style={{ "--dp-promo-scale": scale }}>
      <span className="dp-promo-datecard-month">{month}</span>
      <span className="dp-promo-datecard-day">{day}</span>
    </div>
  );
}
